import { render } from "./ShowVideoZiggeo.vue?vue&type=template&id=7a76b6c9"
import script from "./ShowVideoZiggeo.vue?vue&type=script&lang=js"
export * from "./ShowVideoZiggeo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__